export const INTEREXTRAPOLATE_API_PATHS = {
  FILL_GAPS: "/interextrapolate/fill-gaps",
  REFRESH_EXTRAPOLATION: "/interextrapolate/refresh",
};

export const MISSING_DOCUMENTS_API_PATHS = {
  MISSING_DOCUMENTS: "/aggregations/missing",
  MISSING_DOCUMENTS_EXPORT: "/aggregations/missing/export",
};

export const MISSING_DOCUMENTS_REMINDER_API_PATHS = {
  FORM_DATA: "/aggregations/missing/reminder/form-data",
  SEND: "/aggregations/missing/reminder",
};
